module.exports = __webpack_public_path__ + "static/media/400129_02.6eceb923.png";